import React, {createContext} from 'react';

export interface TabsContextProps {
    value?: string | number;
    tabsId?: string;
    size?: string;
    variant?: 'container' | 'container-outlined';
    handleChange?: (event: React.SyntheticEvent, newValue: number) => void;
}

export const TabsContext = createContext<TabsContextProps | undefined>(undefined);

export const useTabsContext = (currentComponent: string): TabsContextProps => {
    const context = React.useContext(TabsContext);

    if (context === undefined) {
        throw Error(
            `${currentComponent} must be used inside of the Tabs component, otherwise it will not function correctly.`
        );
    }
    return context;
};
